import { Card, useTheme } from "@mui/material";
import { useRef } from "react";
import SalifySideNavbarCategoryList from "../../side-navbar-category-list/side-navbar-category-list";

export interface VariantProps {}

const SalifyScrollableSideNavbarDefault: React.FC<VariantProps> = ({}) => {
  // const router = useRouter();
  const theme = useTheme();

  const cardRef = useRef<HTMLDivElement>(null);

  const handleItemClick = (index: number) => {
    const item = cardRef.current?.children[index] as HTMLElement;
    if (item) {
      const menuList = cardRef.current!;
      const itemOffsetTop = item.offsetTop;
      const itemHeight = item.offsetHeight;

      menuList.scrollTop = itemOffsetTop - menuList.clientHeight / 2 + itemHeight / 2;
    }
  };

  return (
    <Card
      ref={cardRef}
      elevation={1}
      sx={{
        position: "relative",
        maxHeight: "inherit",
        overflowY: "auto",
        "::-webkit-scrollbar": {
          width: 0,
        },
        ":hover": {
          "::-webkit-scrollbar": {
            width: 4,
          },
        },
        "::-webkit-scrollbar-thumb": {
          backgroundColor: theme.palette.primary.main,
          borderRadius: 4,
        },
        "::-webkit-scrollbar-thumb:hover": {
          backgroundColor: theme.palette.primary.dark,
        },
        "::-webkit-scrollbar-track": {
          backgroundColor: "#f1f1f1",
        },
        "& .accordion": {
          padding: 0,
          cursor: "pointer",
          ":hover": {
            color: theme.palette.primary.main,
          },
        },
      }}
    >
      <SalifySideNavbarCategoryList handleItemClick={handleItemClick} />
    </Card>
  );
};

SalifyScrollableSideNavbarDefault.displayName = "SalifyScrollableSideNavbarDefault";

export default SalifyScrollableSideNavbarDefault;
